module.exports = __webpack_public_path__ + "img/production.10bb0442.png";